module.exports = __webpack_public_path__ + "static/media/1001.c0065c44.png";